import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  Link,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { ImageBasic } from "components/Image";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useState } from "react";
import {useNavigate } from "react-router-dom";
import { api } from "services/api";

function Resetpassword() {
  const [isLoading, setIsLoading] = useState(false);
  // const [status, setStatus] = useState("forgotpwd");
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");

  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();

  // const pp = useParams();
  // const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");

  const onSubmit = async () => {
    setIsLoading(true);
    const res = await api.resetpassword({
      password: password,
      cpassword: cpassword,
      token: token,
    });
    setIsLoading(false);
    console.log("forgotpassword", res);

    // if (res?.status === 200) {
    // setStatus("linksendsucess");
    // } else {
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
    // }

    if (res?.status === 200) {
      navigate("/");
    }
  };

  return (
    <Flex
      // h="100vh"
      flex={1}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      p={"2rem"}
    >
      <ImageBasic
        alignSelf={"center"}
        p={"30px"}
        src={"./img/img-brand-logo-dark.png"}
        h={"20rem"}
      />
      <Flex h={"2.5rem"} overflow={"hidden"}>
        {isLoading ? (
          <Spinner size="md" color="spinner" colorPalette={"spinner"} />
        ) : null}
      </Flex>
      <Heading textAlign={"center"} size="xl" color="fontdark" mt="2.5" mb="8">
        Auto Union Warranties Ltd Online Reset Password Page
      </Heading>
      <Flex gap="4" w={ismobile ? "100%" : "400px"} flexDirection={"column"}>
        <Field.Root orientation="horizontal">
          <Field.Label textStyle={"md"}>Password</Field.Label>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>
        <Field.Root orientation="horizontal">
          <Field.Label textStyle={"md"}>Confirm</Field.Label>
          <Input
            type="password"
            value={cpassword}
            onChange={(e) => setCpassword(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>

        <Button onClick={onSubmit} bg="text" size="lg">
          Reset Password
        </Button>

        <Field.Root orientation="horizontal">
          <Box />
          <Link color={"link"} href="/">
            Login
          </Link>
        </Field.Root>
      </Flex>
      <Text textAlign="center" color="text" mt="5%">
        2024 - AU Warranties Ltd
      </Text>
    </Flex>
  );
}

export default Resetpassword;
